import {isFeatureEnabled} from 'feature-flags';
import {showNotification} from 'platform/components';

import {featureFlags} from '@dms/feature-flags';
import i18n from '@dms/i18n';
import {ApiErrorOptions, handleApiError} from '@dms/shared';

import {ApiError} from 'shared/web';

import {isPermissionError} from './isPermissionError';

/**
 * @about Handle an error from a warehouse route that checks the warehouse ACL scopes.
 * With `AFS_WAREHOUSE_ACL_SCOPES` on, an ACL refusal (ACL-FE-ER-0001) shows the standard
 * permission message instead of the technical error. Every other error, and every error with
 * the flag off, goes to `handleApiError` unchanged.
 */
export function handleWarehouseAclApiError(error: ApiError, options?: ApiErrorOptions) {
  if (isFeatureEnabled(featureFlags.AFS_WAREHOUSE_ACL_SCOPES) && isPermissionError(error)) {
    // silent still runs the callbacks, e.g. the unsaved-changes blocker signal
    handleApiError(error, {...options, silent: true});
    showNotification.error(i18n.t('general.notifications.noPermission'));
    return;
  }

  handleApiError(error, options);
}
